import { useSearchParams } from "react-router-dom";
import { parseSortDirection, SortDirection } from "@/components/tables/types";

export type JobListingSortAttribute =
  | "query_cost"
  | "execution_time"
  | "run_count"
  | "last_runtime"
  | "bytes_scanned";

export const useDbtJobListingParams = () => {
  const [searchParams] = useSearchParams();

  const sortAttribute: JobListingSortAttribute =
    (searchParams.get("sortAttribute") as JobListingSortAttribute) || "query_cost";
  const sortOrder: SortDirection = parseSortDirection(
    searchParams.get("sortOrder"),
    "desc"
  );

  return { sortAttribute, sortOrder };
};
